/**
 * useGuests — the guests list, one server page at a time with «عرض المزيد».
 * `total` and `stats` describe the whole filtered set, not the loaded rows
 * (tasks/owner-screens-mobile.md step 2). Same shape as useBookingsPaged.
 */

import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import { guestApi } from '../services/guestApi';

const EMPTY_GUESTS = [];

export const GUESTS_QUERY_KEY = 'guests';

export const useGuestsPaged = (filters = {}, pageSize = 20) => {
  const result = useInfiniteQuery({
    queryKey: [GUESTS_QUERY_KEY, 'paged', filters, pageSize],
    queryFn: ({ pageParam }) => guestApi.getPage({ ...filters, page: pageParam, limit: pageSize }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage?.pagination;
      return p && p.page < p.pages ? p.page + 1 : undefined;
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: 1
  });

  const pages = result.data?.pages;
  return {
    ...result,
    guests: pages ? pages.flatMap(p => p?.guests ?? []) : EMPTY_GUESTS,
    total: pages?.[0]?.pagination?.total ?? 0,
    // Read defensively: the front end can deploy before the backend that adds stats.
    stats: pages?.[0]?.stats ?? null
  };
};

export default useGuestsPaged;
